import { Stripe as StripeObject } from '@stripe/stripe-js';

export default {
  install(Vue: any, { stripePublicKey }: { stripePublicKey: string }) {
    const stripe: StripeObject | undefined =
      window.Stripe && window.Stripe(stripePublicKey);
    Vue.prototype.$stripe = stripe;
  },
};
